// frontend/src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './tailwind.css'; // 导入刚创建的 Tailwind 样式文件
import AppRouter from './AppRouter';
import './index.css'; // 如果有其他全局样式，保持导入
import { store } from './redux/store';

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AppRouter />
    </Provider>
  </React.StrictMode>
);